import React from 'react';
import {Flex} from "../../components/common_style/flex";
import {Background, TopButton} from "./story_editor_styles";
import EditorCanvas from 'components/editor_canvas'
import {ReactComponent as Back} from "../../assets/icons/undo.svg";
import {ReactComponent as Next} from "../../assets/icons/redo.svg";
import {ReactComponent as Plus} from "../../assets/icons/plus_white.svg";
import {ReactComponent as Pages} from "../../assets/icons/pages.svg";
import {ReactComponent as Edit} from "assets/icons/edit.svg";
import {ReactComponent as Home} from "../../assets/icons/home.svg";
import {Span} from "../../components/common_style/text";
import {Colors, FontStyles} from "../../components/constants";
import SlidingPane from "../../components/common_style/sliding_pane";
import ToolsPane from "../../components/tools_pane"
import PagesPaneView from "components/pages_pane";
import TextTools from "components/text_tools";
import {Localization} from "localizations/languages";
import {ReactComponent as Close} from "assets/icons/close_primary.svg";

const iconStyle = {width: '25px', height: '25px', fill: 'white'};
const btnContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    margin: '20px 20px 10px 20px',
    textAlign: 'center',
    pointerEvents: 'auto',
    width: 100,
    height: 120
};

let topLeftStyle = {
    position: 'absolute',
    top: 0,
    left: 0
};

let topCenterStyle = {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0
};


let leftCenterStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0
};


function StoryEditorView(props) {
    let isLastPage = false;
    if (props.pages !== null && props.pageN === props.pages.length - 1) {
        isLastPage = true;
    }
    return <Background>
        <EditorCanvas
            storyDoc={props.storyDoc}
            story={props.story}
            readOnly={props.readOnly}
            page={props.page}
            titleLayout={props.titleLayout}
            maxHeight={props.readOnly ? null : 'calc(100vh - 50px)'}
            maxWidth={props.readOnly ? null : 'calc((100vh - 50px) * 1.77)'}
            width={props.width}
            height={props.height}
            bottomOffset={props.readOnly ? null : '50px'}
            pageN={props.pageN}
            history={props.history}
            closeAllPanes={props.actions.closeAllPanes}
            getCanvasRef={props.getCanvasRef}
            bgImage={props.bgImage != null ? props.bgImage.img : null}
            onDragStart={props.events.onDragStart}
            onTextFocus={props.onTextFocus}
            onDragEnd={props.events.onDragEnd}/>
        <Flex style={{display: props.readOnly ? 'none' : null, pointerEvents: 'none', ...leftCenterStyle}} column
              vAlign={'center'} hAlign={'center'}>
            <span style={{
                visibility: (isLastPage && props.readOnly) ? 'hidden' : null,
                ...btnContainerStyle
            }}>
                <TopButton onClick={props.actions.editTitle} title="Show previous page">
                    <Edit style={iconStyle}/>
                </TopButton>
                <Span textStyle={FontStyles.button}>
                    {Localization.current.translation47}
                </Span>
            </span>
            <span style={btnContainerStyle}>
                    <TopButton onClick={props.actions.togglePages}
                               title="Show pages"
                               style={{backgroundColor: props.pagesOpen ? Colors.primary : Colors.button}}>
                        <Pages style={iconStyle}/>
                    </TopButton>
                    <Span textStyle={FontStyles.button}>
                        {Localization.current.translation13}
                    </Span>
            </span>
            <span
                style={btnContainerStyle}>
                    <TopButton onClick={props.actions.addPage} title="Create new page"
                               style={{marginLeft: 15, marginRight: 15}}>
                        <Plus style={iconStyle}/>
                    </TopButton>
                    <Span textStyle={FontStyles.button}>
                        {Localization.current.translation16}
                    </Span>
                </span>
        </Flex>
        <Flex style={{visibility: !!props.preview ? 'hidden' : null, pointerEvents: 'none', ...topCenterStyle}}
              vAlign={'center'} hAlign={'center'}>
            <span style={btnContainerStyle}>
                    <TopButton onClick={props.actions.back} title="Show previous page">
                        <Back style={iconStyle}/>
                    </TopButton>
                    <Span textStyle={FontStyles.button}>
                        {Localization.current.translation17}
                    </Span>
                </span>
            <span
                style={btnContainerStyle}>
                    <TopButton onClick={props.actions.next} title="show next page"
                               style={{marginLeft: 15, marginRight: 15}}>
                        <Next style={iconStyle}/>
                    </TopButton>
                    <Span textStyle={FontStyles.button}>
                        {Localization.current.translation15}
                    </Span>
                </span>
        </Flex>
        <Flex style={{visibility: !!props.preview ? 'hidden' : null, ...topLeftStyle}}>
            <span style={btnContainerStyle}>
                <TopButton onClick={() => props.actions.finish()} title="Exit the editor">
                    <Home style={iconStyle}/>
                </TopButton>
                <Span textStyle={FontStyles.button}>
                    {Localization.current.translation48}
                </Span>
            </span>
        </Flex>
        <Flex style={{
            visibility: !props.preview ? 'hidden' : null,
            bottom: '5%',
            position: 'absolute',
            left: '3%',
            right: '3%'
        }}>
            <Back onClick={props.actions.back} style={{
                filter: 'drop-shadow(0 0 3px rgba(0, 0, 0, .7))',
                cursor: 'pointer',
                marginRight: 'auto', ...iconStyle
            }}/>
            <Next onClick={props.actions.next}
                  style={{filter: 'drop-shadow(0 0 3px rgba(0, 0, 0, .7))', cursor: 'pointer', ...iconStyle}}/>
        </Flex>


        {props.readOnly ? null : <SlidingPane
            open={props.toolsOpen}
            bottom
            size={'50vh'}
            offset={'50px'}
            style={{
                boxShadow: '0 -1px 0 0 #FF6425, 0 0 10px 0 rgba(0,0,0,0.5)',
                backgroundColor: Colors.primaryShade,
            }}
            onMouseLeave={props.events.paneMouseLeave}>
            <ToolsPane
                parentKey={props.parentKey}
                onDragStart={props.events.onDragStart}
                onDragEnd={props.events.onDragEnd}
                bgClick={props.toolsEventHandlers.background}
                close={() => props.actions.closeTools()}
                tabChanged={(_) => props.actions.openTools()}
            />
        </SlidingPane>}
        <SlidingPane
            open={props.pagesOpen}
            right
            size={'400px'}
            style={{
                boxShadow: '-1px 0 0 0 #FF6425, 0 0 10px 0 rgba(0,0,0,0.5)',
                backgroundColor: Colors.primaryShade,
                marginRight: '-1px'
            }}
            onMouseLeave={props.events.paneMouseLeave}>
            <PagesPaneView
                pages={props.pages}
                setPage={props.actions.setPage}
                pageN={props.pageN}
                deletePage={props.actions.deletePage}
                reorderPages={props.actions.reorderPages}
                addPage={props.actions.addPage}
            />
            <div onClick={props.actions.togglePages}
                 style={{cursor: 'pointer', position: 'absolute', top: 15, right: 15}}><Close/></div>
        </SlidingPane>
        <SlidingPane
            open={props.textToolsOpen}
            bottom
            size={'200px'}
            style={{
                boxShadow: '0 -1px 0 0 #FF6425, 0 0 10px 0 rgba(0,0,0,0.5)',
                backgroundColor: Colors.primaryShade,
                marginBottom: '-1px'
            }}
            onMouseLeave={props.events.paneMouseLeave}>
            <TextTools
                onSizeChange={props.toolsEventHandlers.textSize}
                onColoChange={props.toolsEventHandlers.textColor}
                onDone={props.toolsEventHandlers.onDone}
                styles={!!props.textPItem ? props.textPItem.textOverlay.styles : null}
            />
        </SlidingPane>
    </Background>;
}

export default StoryEditorView;
